import { CurrentUserFetcher } from "@indietabletop/appkit";
import { Redirect, Route, Switch } from "wouter";
import {
  EmailChangePage,
  JoinPage,
  LoginPage,
  PasswordResetPage,
} from "../Account/Account";
import { UnlocksFetcher } from "../CheckAccess/CheckAccess";
import { DashboardPage } from "../DashboardPage/DashboardPage";
import { GravehelmPage } from "../Gravehelm/GravehelmPage";
import { DocRoutes } from "../HelpPages/DocsPages";
import { KnightlyOrdersPage } from "../KnightlyOrdersPage/KnightlyOrdersPage";
import { NotFoundPage } from "../NotFoundPage/NotFoundPage";
import { CheckoutSuccessPage } from "../oss/CheckoutSuccessPage/CheckoutSuccessPage";
import { MainLayout } from "../oss/Layout/Layout";
import { PrintPage } from "../PrintPage/PrintPage";
import { RedeemPage } from "../RedeemPage/RedeemPage";
import { SettingsPage } from "../SettingsPage/SettingsPage";
import { ShareAppPage } from "../ShareAppPage/ShareAppPage";
import { ShopPage } from "../ShopPage/ShopPage";
import { Spine } from "../Spine/Spine";
import { SharedWarbandPage, WarbandPage } from "../WarbandPage/WarbandPage";
import { DebugPage } from "./DebugPage";
import { href } from "./href";

export function Routes() {
  return (
    <Switch>
      <Route path="/builder/w/:warbandId/print">
        <PrintPage />
      </Route>

      <Route>
        <MainLayout spine={<Spine />}>
          <Switch>
            <Route path="/downloads">
              <Redirect
                replace
                to={href("~/shop", { search: { note: "loginNeeded" } })}
              />
            </Route>

            <Route path="/rules">
              <Redirect replace to={href("~/shop")} />
            </Route>

            <Route path="/gravehelm">
              <GravehelmPage />
            </Route>

            <Route path="/debug">
              <DebugPage />
            </Route>

            <Route path="/share">
              <ShareAppPage />
            </Route>

            <Route path="/login">
              <LoginPage />
            </Route>

            <Route path="/join">
              <JoinPage />
            </Route>

            <Route path="/change-email">
              <EmailChangePage />
            </Route>

            <Route path="/password">
              <PasswordResetPage />
            </Route>

            <Route>
              <CurrentUserFetcher>
                <UnlocksFetcher>
                  <Switch>
                    <Route path="/">
                      <DashboardPage />
                    </Route>

                    <Route path="/shop">
                      <ShopPage />
                    </Route>

                    <Route path="/redeem/:id">
                      <RedeemPage />
                    </Route>

                    <Route path="/builder">
                      <KnightlyOrdersPage />
                    </Route>

                    <Route path="/builder/w/:warbandId" nest>
                      <WarbandPage />
                    </Route>

                    <Route path="/shared/w/:warbandId" nest>
                      <SharedWarbandPage />
                    </Route>

                    <Route path="/settings">
                      <SettingsPage />
                    </Route>

                    <Route path="/checkout/sessions/:sessionId">
                      <CheckoutSuccessPage />
                    </Route>

                    <Route path="/docs" nest>
                      <DocRoutes />
                    </Route>

                    <Route>
                      <NotFoundPage />
                    </Route>
                  </Switch>
                </UnlocksFetcher>
              </CurrentUserFetcher>
            </Route>
          </Switch>
        </MainLayout>
      </Route>
    </Switch>
  );
}
